import { Stack } from 'expo-router';

import { MqSwitch } from '@fhs/ui';

import { getScreenTitleHeader } from '../../components/get-screen-title-header';

const MenuIndexStackHeader = getScreenTitleHeader();

export default function MenuLayout() {
  return (
    <Stack>
      <Stack.Screen
        name="(menu)/index"
        options={{
          header: props => (
            <MqSwitch $ltDesktop={() => <MenuIndexStackHeader {...props} />} />
          ),
          title: 'Menu',
        }}
      />
      <Stack.Screen
        name="(menu)/[slug]"
        options={{ header: getScreenTitleHeader(), title: '', headerShown: false }}
      />
    </Stack>
  );
}
